var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSkillBlobSm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 350.469,
    height: 454.856,
    viewBox: "0 0 350.469 454.856",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "z",
    x1: 0.383,
    y1: 0.225,
    x2: 0.428,
    y2: 1.005,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff0057",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#e5bf00",
    stopOpacity: 0
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M105.945,171.354c22.92-60.053,107.878-60.053,130.8,0l69.7,182.63c17.489,45.824-16.351,94.96-65.4,94.96h-139.4c-49.048,0-82.888-49.136-65.4-94.96Z",
    transform: "matrix(1, 0.017, -0.017, 1, 7.835, 0)",
    fill: "url(#z)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkillBlobSm);
export default __webpack_public_path__ + "static/media/skill-blob-sm.3034afd3231053fe1271c004621800a9.svg";
export { ForwardRef as ReactComponent };